/**
 * src/shell/ui/components/Toasts.tsx — 壳层提示条容器。
 */

import { dismissToast } from '../../gm-client/toast'
import { useToasts } from '../../gm-client/hooks'

export function Toasts() {
  const toasts = useToasts()
  if (toasts.length === 0) return null
  return (
    <div className="toast-stack">
      {toasts.map((t) => (
        <div key={t.id} className="toast" onClick={() => dismissToast(t.id)}>
          {t.text}
        </div>
      ))}
    </div>
  )
}
